import * as React from 'react';
import { connect } from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import { browserHistory } from 'react-router';
import { FaHardHat, FaTshirt } from 'react-icons/fa'; // Updated icons

// Inject animated gradient keyframes once
const ensureGradientKeyframes = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById('pj-gradient-anim')) return;
  const style = document.createElement('style');
  style.id = 'pj-gradient-anim';
  style.innerHTML = `
    @keyframes gradientBackground {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `;
  document.head.appendChild(style);
};
ensureGradientKeyframes();

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(270deg, #008e6a, #00a77d, #D22328, #0099ff)',
    backgroundSize: '800% 800%',
    animation: 'gradientBackground 15s ease infinite',
    color: '#FFF',
    fontFamily: "'Montserrat', sans-serif",
    padding: '20px',
    textAlign: 'center',
    transition: 'opacity 0.5s ease',
    opacity: 0.95,
  },
  header: {
    margin: '0 0 20px 0',
    fontSize: '2.5em',
    fontWeight: 'bold',
  },
  description: {
    fontSize: '1.2em',
    maxWidth: '600px',
    lineHeight: '1.5',
  },
  button: {
    fontSize: '1em',
    padding: '15px 30px',
    backgroundColor: '#FFF',
    color: '#008e6a',
    border: '2px solid #FFF',
    borderRadius: '50px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '20px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
  }
};

interface Props {}
interface State {}

class PapaJohnsMicroStore extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleGetStartedClick = () => {
    browserHistory.push(Tgcc.Routes.PapaJohnsShirtOfTheMonthClub);
  };

  render() {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          <FaHardHat style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.5em' }} />
          This page is under construction
        </h1>
        <p style={styles.description}>
          We're working hard to build something awesome. In the meantime, feel free to check out our Shirt of the Month!
        </p>
        <button
          style={styles.button}
          onClick={this.handleGetStartedClick}
          onMouseEnter={e => {
            const buttonStyle = e.currentTarget.style;
            buttonStyle.transform = 'scale(1.05)';
            buttonStyle.boxShadow = '0 8px 16px rgba(0,0,0,0.3)';
            buttonStyle.backgroundColor = '#D22328';
            buttonStyle.color = '#FFF';
            buttonStyle.borderColor = '#008e6a';
          }}
          onMouseLeave={e => {
            const buttonStyle = e.currentTarget.style;
            buttonStyle.transform = 'scale(1)';
            buttonStyle.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            buttonStyle.backgroundColor = '#FFF';
            buttonStyle.color = '#008e6a';
            buttonStyle.borderColor = '#FFF';
          }}
        >
          <FaTshirt style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.2em' }} />
          Explore Shirt of the Month
        </button>
      </div>
    );
  }
}

export default PapaJohnsMicroStore;

/*
====================================================
ORIGINAL VERSION (commented out for future reference)
====================================================

import * as React from 'react';
import { connect } from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import { browserHistory } from 'react-router';
import { FaPizzaSlice, FaTshirt, FaPencilRuler } from 'react-icons/fa'; // Import FaEye for the new button icon

const styles: { [key: string]: React.CSSProperties } = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #008e6a 0%, #00a77d 100%)',
      color: '#FFF',
      fontFamily: "'Montserrat', sans-serif",
      padding: '20px',
      textAlign: 'center',
    },
    header: {
      margin: '0 0 20px 0',
      fontSize: '2.5em',
      fontWeight: 'bold',
    },
    description: {
      fontSize: '1.2em',
      maxWidth: '600px',
      lineHeight: '1.5',
    },
    button: {
      fontSize: '1em',
      padding: '15px 30px',
      backgroundColor: '#FFF',
      color: '#008e6a',
      border: '2px solid #FFF',
      borderRadius: '50px',
      boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
      cursor: 'pointer',
      textDecoration: 'none',
      display: 'inline-block',
      marginTop: '20px',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
    }
  };

interface Props {}
interface State {}

class PapaJohnsMicroStore extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  handleGetStartedClick = () => {
    browserHistory.push(Tgcc.Routes.PapaJohnsRegister);
  };

  handleViewDesignsClick = () => {
    browserHistory.push(Tgcc.Routes.ViewPapaJohnsDesigns);
  };

  render() {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          <FaPizzaSlice style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.5em' }} />
          Custom Papa John's Gear
        </h1>
        <p style={styles.description}>
          Dive into the world of custom apparel designed especially for Papa John's. Start your journey by selecting the perfect shirt color, design, and watch your vision come to life.
        </p>
        <button
          style={styles.button}
          onClick={this.handleGetStartedClick}
          onMouseEnter={e => {
            const buttonStyle = e.currentTarget.style;
            buttonStyle.transform = 'scale(1.05)';
            buttonStyle.boxShadow = '0 8px 16px rgba(0,0,0,0.3)';
            buttonStyle.backgroundColor = '#D22328';
            buttonStyle.color = '#FFF';
            buttonStyle.borderColor = '#008e6a';
          }}
          onMouseLeave={e => {
            const buttonStyle = e.currentTarget.style;
            buttonStyle.transform = 'scale(1)';
            buttonStyle.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            buttonStyle.backgroundColor = '#FFF';
            buttonStyle.color = '#008e6a';
            buttonStyle.borderColor = '#FFF';
          }}
        >
          <FaTshirt style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.2em' }} />
          Get Started
        </button>
      </div>
    );
  }
}
*/
